import React from 'react'

const Area = () => {
  return (
    <div>
      
    </div>
  )
}

export default Area
